import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import quickLoginService from "../lib/quicklogin.service";
import { deviceKeys } from "./use-devices";

export const quickLoginKeys = {
  detail: (deviceId: string) =>
    [...deviceKeys.detail(deviceId), "quicklogins"] as const,
};

/** useDeviceQuickLogins reads a device's QuickLogin backup status. */
export function useDeviceQuickLogins(deviceId: string) {
  return useQuery({
    queryKey: quickLoginKeys.detail(deviceId),
    queryFn: () => quickLoginService.get(deviceId),
    staleTime: 15_000,
    retry: false, // 4xx/5xx here are config or data problems, not blips
  });
}

export function useDeleteQuickLogins(deviceId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => quickLoginService.delete(deviceId),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: quickLoginKeys.detail(deviceId) }),
  });
}
